const translations = {
  en: {
    // Quick ballot banner
    manOfTheMatch: "Man\u00a0of\u00a0the\u00a0Match",
    poweredBy: "Powered by",
    home: "HOME",
    vs: "VS.",
    opponent: "Opponent",
    sort: "Sort",
    voteForMotm: "Vote for MoTM",

    // Regular ballot
    votingIsLive: "Voting is live",
    inProgress: "In progress",
    selectYourCandidates: "Select your candidates",
    position: "Position",
    reviewAndSubmit: "Review & Submit",
    submitVote: "Submit Vote",
    continue: "Continue",

    // Ballot summary
    ballotSummary: "Ballot Summary",
    question: "Question",
    noAnswerSelected: "No answer selected",
    confirmAndSubmit: "Confirm and Submit",

    // Error / loading states
    returnHome: "Return Home",
    resetVoterStatus: "Reset Voter Status (Debug)",
    noBallotData: "No ballot data available. The ballot may have been removed or is no longer active.",
    failedToLoad: "Failed to load ballot. This ballot may no longer be available or the link is invalid.",
    pleaseSelect: "Please select an option to proceed.",

    // Success dialog
    wayToGo: "Way to go,",
    yourVoiceMatters: "Your voice matters",
    voteRecorded: "Vote successfully recorded",
    thankYou: "Thank you,",
    ballotSecurelySubmitted: "Your ballot has been securely submitted. Every vote counts in making this election fair.",
    viewLiveResults: "View Live Results",
    next: "Next",

    // Quick ballot confirm
    youAreAboutToVoteFor: "You are about to vote for",
    from: "from",
    confirmVote: "Confirm Vote",
    goBack: "\u2190 Go back",

    // Thank you screen
    thanksForVoting: "Thanks for Voting!",
    youVotedFor: "You voted for",
    resultsAnnounced: "Results will be announced 15 mins after the match.",
    share: "Share",

    // Not started / closed dialogs
    votingNotStarted: "Voting hasn't started yet",
    pollsOpenAt: "Polls open at",
    theScheduledTime: "the scheduled time",
    gotIt: "Got it",
    votingIsOver: "Voting is over!",
    pollsClosed: "Polls are now closed! Check out the final results.",
    viewResults: "View Results",

    // Confirmation dialog
    confirmation: "Confirmation",
    cannotChangeAfter: "You cannot change your response after. If you are sure you want to submit, enter your digital key below.",
    pasteDigitalKey: "Paste Your Digital Key Here",
    pleaseEnterKey: "Please enter your digital key",
    invalidKey: "Invalid digital key. Please check and try again.",
    submit: "Submit",

    // Welcome page
    appName: "SafeBallot",
    welcomeSubtitle1: "Secure digital voting for your school.",
    welcomeSubtitle2: "Every vote counts.",
    whatsYourName: "What's your name?",
    enterFirstName: "Enter your first name",
    settingUp: "Setting up...",
    getStarted: "Get Started",

    // Registration page
    castYourVote: "Cast Your Vote",
    registerToVoteIn: "Register to vote in",
    registerToParticipate: "Register to participate in this election.",
    yourVoiceMattersSubtitle: "Your voice matters.",
    yourName: "Your name",
    enterFullName: "Enter your full name",
    pleaseEnterName: "Please enter your name",
    somethingWentWrong: "Something went wrong. Please try again.",
    registering: "Registering...",
    registerAndVote: "Register & Vote",
    secureVoting: "Secure and transparent voting made easy",

    // Language toggle
    english: "EN",
    spanish: "ES",
  },
  es: {
    // Quick ballot banner
    manOfTheMatch: "Jugador\u00a0del\u00a0Partido",
    poweredBy: "Presentado por",
    home: "LOCAL",
    vs: "VS.",
    opponent: "Oponente",
    sort: "Ordenar",
    voteForMotm: "Votar JdP",

    // Regular ballot
    votingIsLive: "Votaci\u00f3n en vivo",
    inProgress: "En curso",
    selectYourCandidates: "Selecciona tus candidatos",
    position: "Posici\u00f3n",
    reviewAndSubmit: "Revisar y Enviar",
    submitVote: "Enviar Voto",
    continue: "Continuar",

    // Ballot summary
    ballotSummary: "Resumen de la Boleta",
    question: "Pregunta",
    noAnswerSelected: "Ninguna respuesta seleccionada",
    confirmAndSubmit: "Confirmar y Enviar",

    // Error / loading states
    returnHome: "Volver al Inicio",
    resetVoterStatus: "Restablecer Estado del Votante (Debug)",
    noBallotData: "No hay datos de boleta disponibles. La boleta puede haber sido eliminada o ya no est\u00e1 activa.",
    failedToLoad: "No se pudo cargar la boleta. Esta boleta puede que ya no est\u00e9 disponible o el enlace no es v\u00e1lido.",
    pleaseSelect: "Por favor selecciona una opci\u00f3n para continuar.",

    // Success dialog
    wayToGo: "\u00a1Muy bien,",
    yourVoiceMatters: "Tu voz importa",
    voteRecorded: "Voto registrado exitosamente",
    thankYou: "\u00a1Gracias,",
    ballotSecurelySubmitted: "Tu boleta ha sido enviada de forma segura. Cada voto cuenta para una elecci\u00f3n justa.",
    viewLiveResults: "Ver Resultados en Vivo",
    next: "Siguiente",

    // Quick ballot confirm
    youAreAboutToVoteFor: "Est\u00e1s a punto de votar por",
    from: "de",
    confirmVote: "Confirmar Voto",
    goBack: "\u2190 Regresar",

    // Thank you screen
    thanksForVoting: "\u00a1Gracias por Votar!",
    youVotedFor: "Votaste por",
    resultsAnnounced: "Los resultados se anunciar\u00e1n 15 minutos despu\u00e9s del partido.",
    share: "Compartir",

    // Not started / closed dialogs
    votingNotStarted: "La votaci\u00f3n a\u00fan no ha comenzado",
    pollsOpenAt: "Las urnas abren a las",
    theScheduledTime: "la hora programada",
    gotIt: "Entendido",
    votingIsOver: "\u00a1La votaci\u00f3n termin\u00f3!",
    pollsClosed: "\u00a1Las urnas est\u00e1n cerradas! Consulta los resultados finales.",
    viewResults: "Ver Resultados",

    // Confirmation dialog
    confirmation: "Confirmaci\u00f3n",
    cannotChangeAfter: "No puedes cambiar tu respuesta despu\u00e9s. Si est\u00e1s seguro de enviar, ingresa tu clave digital abajo.",
    pasteDigitalKey: "Pega Tu Clave Digital Aqu\u00ed",
    pleaseEnterKey: "Por favor ingresa tu clave digital",
    invalidKey: "Clave digital inv\u00e1lida. Por favor verifica e intenta de nuevo.",
    submit: "Enviar",

    // Welcome page
    appName: "SafeBallot",
    welcomeSubtitle1: "Votaci\u00f3n digital segura para tu escuela.",
    welcomeSubtitle2: "Cada voto cuenta.",
    whatsYourName: "\u00bfC\u00f3mo te llamas?",
    enterFirstName: "Ingresa tu nombre",
    settingUp: "Preparando...",
    getStarted: "Comenzar",

    // Registration page
    castYourVote: "Emite Tu Voto",
    registerToVoteIn: "Reg\u00edstrate para votar en",
    registerToParticipate: "Reg\u00edstrate para participar en esta elecci\u00f3n.",
    yourVoiceMattersSubtitle: "Tu voz importa.",
    yourName: "Tu nombre",
    enterFullName: "Ingresa tu nombre completo",
    pleaseEnterName: "Por favor ingresa tu nombre",
    somethingWentWrong: "Algo sali\u00f3 mal. Por favor intenta de nuevo.",
    registering: "Registrando...",
    registerAndVote: "Registrar y Votar",
    secureVoting: "Votaci\u00f3n segura y transparente",

    // Language toggle
    english: "EN",
    spanish: "ES",
  },
};

export default translations;
